import React, { useContext } from "react";
import { CSContext } from "../contexts/CSContext";
import { toast } from "Components/DesignSystem/Toast/useToast";
import Button from "Components/DesignSystem/Button/Button";

function CSCreateButton(props: any) {
    const { setPivotVersionList } = useContext(CSContext)

    return (
        <div className="tw-flex tw-m-2 tw-justify-end">
            <Button variant="primary" data-testid="substitutions-create-version-btn"
                onClick={() => {
                    if (props?.selectedIndex === undefined || props?.selectedIndex === null) toast.info("select one of the versions from the table")
                    else setPivotVersionList([]);
                }}
            >Create Version</Button>
        </div>
    );
}

export default CSCreateButton
